import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultEnum } from "../../types.client";
import { EmergencyBellSensitivityMeasure } from "../../../models/schemas/measures/wireless.schema";
import { EMERGENCY_BELL_SENSITIVITY_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 비상벨 수신감도 컨트롤러
 * 기준: 측정값 >= EMERGENCY_BELL_SENSITIVITY_THRESHOLDS.min (-100dBm)이면 양호
 */
export class EmergencyBellSensitivityController extends MeasureController<EmergencyBellSensitivityMeasure> {
  protected getDefaultData(): EmergencyBellSensitivityMeasure {
    return {
      standardValue: -100,
      measuredValue: 0,
      unit: "dBm",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
      createdAt: null,
    };
  }

  protected judge(): JudgmentResult {
    const { measuredValue = 0 } = this.data;
    const threshold = EMERGENCY_BELL_SENSITIVITY_THRESHOLDS.min;

    const result = measuredValue >= threshold ? JudgmentResultEnum.GOOD : JudgmentResultEnum.BAD;
    const discussion = this.generateDiscussion(result);

    return { result, discussion };
  }

  protected generateDiscussion(result: "GOOD" | "CAUTION" | "BAD" | "NA"): string {
    const { measuredValue = 0 } = this.data;
    const threshold = EMERGENCY_BELL_SENSITIVITY_THRESHOLDS.min;

    if (result === JudgmentResultEnum.GOOD) {
      return `측정값 ${measuredValue}dBm, 기준 ${threshold}dBm 이상으로 양호`;
    } else {
      return `측정값 ${measuredValue}dBm, 기준 ${threshold}dBm 미만으로 불량`;
    }
  }
}
